import { axiosCompanyPortalInstance } from "./";

/**
 * Company portal auth/session APIs (same paths as admin where applicable, different base URL).
 * Add registration, OTP, etc. here as the company flow grows.
 */

const companyLogin = async (payload) =>
  axiosCompanyPortalInstance.post("/sessions", payload);

const companyLogout = async (payload) =>
  axiosCompanyPortalInstance.delete("/sessions", { data: payload });

const companyChangePassword = async (payload) =>
  axiosCompanyPortalInstance.post("/company_users/change_password", payload);

const companyForgetPassword = async (payload) =>
  axiosCompanyPortalInstance.post("/company_users/forgot_password", payload);

export {
  companyLogin,
  companyLogout,
  companyChangePassword,
  companyForgetPassword,
};
